import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { convertHexToRGBA } from '../../utils'

const styles = (theme: any) => ({
  superView: {
    flex: 1,
    backgroundColor: theme?.bodyBgColor,
    overflowY: 'auto',
  } as BoxProps,
  buttonBgView: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  actionButtonContainer: {
    marginTop: 16,
    bottom: 0,
    alignSelf: 'flex-end',
    right: 0,
    paddingBottom: 16,
  } as BoxProps,
  mobileActionButtonContainer: {
    marginTop: 16,
    bottom: 0,
    alignSelf: 'flex-end',
    right: 0,
    paddingBottom: 16,
    width: '100%',
  } as BoxProps,
  title: {
    fontSize: 12,
    fontWeight: '500',
    color: convertHexToRGBA(theme.bodyTextColor, 50) as ColorOptions,
  } as TextProps,
  subTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: theme.bodyTextColor as ColorOptions,
  } as TextProps,
})

export const maxCardLength = {
  none: 16,
  rupay: 16,
  maestro: 16,
  discover: 16,
  mastercard: 16,
  diners: 16,
  amex: 17,
  visa: 16,
}

export const maxCVVLength = {
  none: 3,
  rupay: 3,
  maestro: 3,
  discover: 3,
  mastercard: 3,
  diners: 3,
  amex: 4,
  visa: 3,
}

export default styles
